import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const useReferrals = () => useQuery({ queryKey: ["referrals"], queryFn: () => api.get("/referrals/me").then((r) => r.data), staleTime: 300000 });

export const RewardWatcher = () => {
  const { data } = useReferrals();
  const { reload } = useAuth();
  const qc = useQueryClient();
  useEffect(() => {
    if (!data?.new_rewards) return;
    toast.success(data.new_rewards > 1 ? `Your friends joined LoreRight. You earned ${data.new_rewards} free months of Pro!` : "Five friends joined LoreRight. You earned a free month of Pro!", { duration: 8000 });
    api.post("/referrals/ack").then(() => { qc.setQueryData(["referrals"], (d) => d && { ...d, new_rewards: 0 }); reload?.(); }).catch(() => {});
  }, [data?.new_rewards, qc, reload]);
  return null;
};
